var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C4 20.4477 4.44772 20 5 20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.067 5.14885C11.8685 4.95039 11.5467 4.95038 11.3483 5.14884L7.40605 9.09104C7.20758 9.2895 7.20758 9.61127 7.40604 9.80973L12.1902 14.594C12.3887 14.7924 12.7105 14.7924 12.9089 14.594L16.8512 10.6518C17.0496 10.4533 17.0496 10.1315 16.8512 9.93307L12.067 5.14885Z",
    fill: "#6B92FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7474 16.4766C10.9143 16.4302 10.9454 16.2239 10.8229 16.1014L5.8986 11.177C5.77612 11.0546 5.56977 11.0857 5.52338 11.2526L4.04213 16.5813C3.80914 17.4194 4.58056 18.1909 5.41873 17.9579L10.7474 16.4766Z",
    fill: "#6B92FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5167 2.90525C14.7238 1.69824 16.6807 1.69825 17.8877 2.90526L19.0947 4.11228C20.3018 5.31931 20.3018 7.27628 19.0947 8.48329L18.7289 8.84912C18.5277 9.05029 18.2016 9.05029 18.0004 8.84912L13.1509 3.99961C12.9497 3.79844 12.9497 3.47228 13.1509 3.27111L13.5167 2.90525Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFilled);
export default __webpack_public_path__ + "static/media/EditFilled.a2d57a84.svg";
export { ForwardRef as ReactComponent };